import React, { useEffect, useState } from "react";
import ViewLogsContainer from "./ViewLogsContainer";
import ViewLogsTable from "./ViewLogsTable";
import ViewLogsFooter from "./ViewLogsFooter";
import "./viewLog.scss";
import { convertToFilterMenuFormat } from "./ViewLogsHelper";
import {
  MY_VACATIONS,
  MY_VACATIONS_RADIO_BTN,
  VIEW_LOGS_MAP,
} from "../Constants";

const ViewLogs = ({
  addClass,
  setAddClass,
  logType,
  procedureDropDown,
  roleNameMenu,
  tableData,
  handleViewLogOnFilter,
  logFilterData,
  totalRecords,
  selectedRadioBtn,
  handleRadioBtn,
}) => {
  const [headerData, setHeaderData] = useState([]);
  const [logs, setLogs] = useState([]);
  const [apiParams, setApiParams] = useState({
    page_number: 1,
  });
  const [totalTableDataCount, settotalTableDataCount] = useState(0);

  useEffect(() => {
    if (logFilterData) {
      let headerData = [...VIEW_LOGS_MAP[logType].HEADERS];

      if (
        logType === MY_VACATIONS &&
        selectedRadioBtn === MY_VACATIONS_RADIO_BTN
      ) {
        headerData = headerData?.filter(
          (data) => data?.title !== "CONSULTATION"
        );
      }
      headerData.forEach((obj) => {
        if (obj.title === "CONSULTATION") {
          let convertedMenu = convertToFilterMenuFormat(procedureDropDown);
          let procedureMenu = [
            { name: "All", value: "all", id: "0", selected: false },
            ...convertedMenu,
          ];
          if (logFilterData?.consultation_filter) {
            let indx = procedureMenu.findIndex(
              (d) => d.name === logFilterData?.consultation_filter
            );
            if (indx > -1) {
              let items = obj?.tempMenu?.forEach((item) => {
                item.selected = false;
              });
              let items1 = obj?.menuData?.forEach((item) => {
                item.selected = false;
              });
              procedureMenu[indx].selected = true;
            }
          }
          obj.show_filter = false;
          obj.menuData = procedureMenu;
          obj.tempMenu = procedureMenu;
        }
        if (obj.title === "ACTION") {
          if (logType === "UPDATE_SCHEDULE") {
            if (logFilterData?.action_filter) {
              let index = obj?.tempMenu?.findIndex(
                (d) => d?.value === logFilterData?.action_filter
              );
              if (index > -1) {
                let items = obj?.tempMenu?.forEach((item) => {
                  item.selected = false;
                });
                obj.tempMenu[index].selected = true;
                obj.menuData = obj.tempMenu;
              }
            } else {
              let index = obj?.tempMenu?.findIndex((d) => d?.value === "all");
              if (index > -1) {
                let items = obj?.tempMenu?.forEach((item) => {
                  item.selected = false;
                });
                obj.tempMenu[index].selected = true;
                obj.menuData = obj.tempMenu;
              }
            }
          }
        }
        if (obj.title === "ROLE NAME") {
          let convertedRoleName = roleNameMenu
            ? convertToFilterMenuFormat(roleNameMenu)
            : [];
          let roleMenu = [
            { name: "All", value: "all", id: 0, selected: false },
            ...convertedRoleName,
          ];
          if (logFilterData?.doctor_name_filter) {
            let indx = roleMenu.findIndex(
              (d) => d?.value === logFilterData?.doctor_name_filter
            );
            if (indx > -1) {
              let items = obj?.menuData?.forEach((item) => {
                item.selected = false;
              });
              let items1 = obj?.tempMenu?.forEach((item) => {
                item.selected = false;
              });
              roleMenu[indx].selected = true;
            }
          }
          obj.menuData = roleMenu;
          obj.tempMenu = roleMenu;
        }

        if (obj.title === "ROLE") {
          if (logFilterData?.role_filter) {
            let index = obj?.menuData?.findIndex(
              (d) => d?.value === logFilterData?.role_filter
            );
            if (index > -1) {
              let items = obj?.menuData?.forEach((item) => {
                item.selected = false;
              });
              obj.menuData[index].selected = true;
            }
          } else {
            let index = obj?.menuData?.findIndex((d) => d?.value === "all");
            if (index > -1) {
              let items = obj?.menuData?.forEach((item) => {
                item.selected = false;
              });
              obj.menuData[index].selected = true;
            }
          }
        }
      });
      setApiParams(logFilterData);
      setHeaderData(headerData);
    }
  }, [procedureDropDown, roleNameMenu, logFilterData]);

  useEffect(() => {
    let currentTableData = tableData && tableData[logType];
    setLogs(currentTableData);
  }, [tableData]);

  useEffect(() => {
    settotalTableDataCount(totalRecords);
  }, [totalRecords]);

  const applyParams = (params) => {
    setApiParams({ ...params });
    handleViewLogOnFilter(params);
  };
  const getFooter = () => {
    return (
      <ViewLogsFooter
        currentPage={apiParams?.page_number}
        totalCount={totalTableDataCount || 0}
        pageSize={10}
        onPageChange={(number) =>
          applyParams({ ...apiParams, page_number: number })
        }
      />
    );
  };
  const getTableData = () => {
    return (
      <ViewLogsTable
        key={logType}
        logType={logType}
        headerData={headerData}
        tableData={logs?.length > 0 && logs}
        applyParams={applyParams}
        params={apiParams}
        selectedRadioBtn={selectedRadioBtn}
        logFilterData={logFilterData}
      />
    );
  };

  return (
    <>
      <ViewLogsContainer
        addClass={addClass}
        setAddClass={setAddClass}
        drawerTitle={"Logs"}
        logType={logType}
        handleRadioBtn={handleRadioBtn}
        selectedRadioBtn={selectedRadioBtn}
      >
        <div className="py-2">
          {getTableData()}
          {logs?.length > 0 && getFooter()}
        </div>
      </ViewLogsContainer>
    </>
  );
};

export default ViewLogs;
